export default __webpack_public_path__ + "static/case-study-fc68117dbfcf2a1d0528e9d95f521a49.svg";